// extracted by mini-css-extract-plugin
export var closeButton = "_ol-2";
export var closeButtonIcon = "_ol-3";
export var lightboxContent = "_ol-1";
export var lightboxOverlay = "_ol-0";